const PAPER_BOX_PROPS = {
  elevation: 0,
  sx: {
    borderRadius: '4px',
    border: '1px solid #EEEDED',
  },
};
export default PAPER_BOX_PROPS;
